export default __webpack_public_path__ + "app/assets/sostenibilita-a23d1fef.png";